export const logoutApi = async () => {
  sessionStorage.clear();
  window.location.replace('/');
};
